import React from 'react';
import { cn } from '../utils/cn';
export const Select = React.forwardRef(function Select(
  { label, helperText, error, placeholder, className, id, children, ...props },
  ref,
) {
  const selectId = id || React.useId();
  const helperId = `${selectId}-helper`;
  const errorId = `${selectId}-error`;
  return (
    <div className="w-full">
      {label && (
        <label htmlFor={selectId} className="mb-1 block text-sm font-medium text-fg-secondary">
          {label}
        </label>
      )}
      <select
        ref={ref}
        id={selectId}
        className={cn(
          'block w-full appearance-none rounded-md border bg-surface px-3 py-2 pr-8 text-sm text-fg transition-colors duration-150',
          'focus:outline-none focus:ring-2 focus:ring-offset-0',
          "bg-[url('data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22%236b7280%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20d%3D%22M5.23%207.21a.75.75%200%20011.06.02L10%2011.168l3.71-3.938a.75.75%200%20111.08%201.04l-4.25%204.5a.75.75%200%2001-1.08%200l-4.25-4.5a.75.75%200%2001.02-1.06z%22%20clip-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E')] bg-[length:1.25rem_1.25rem] bg-[position:right_0.5rem_center] bg-no-repeat",
          error
            ? 'border-danger-500 focus:ring-danger-500/25'
            : 'border-edge focus:border-primary-500 focus:ring-primary-500/25',
          props.disabled && 'bg-surface-secondary opacity-75 cursor-not-allowed',
          className,
        )}
        aria-invalid={error ? true : undefined}
        aria-describedby={error ? errorId : helperText ? helperId : undefined}
        {...props}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {children}
      </select>
      {error && (
        <p id={errorId} className="mt-1 text-sm text-danger-600" role="alert">
          {error}
        </p>
      )}
      {!error && helperText && (
        <p id={helperId} className="mt-1 text-sm text-fg-tertiary">
          {helperText}
        </p>
      )}
    </div>
  );
});
